var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignOutHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1267 6.06787L20 9.9999L16.1267 13.9319L15.1074 12.8971L17.2406 10.7316H8.40918V9.26819H17.2406L15.1074 7.10266L16.1267 6.06787Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.68293C0 1.20119 1.18326 0 2.64288 0H11.2923C12.7519 0 13.9352 1.20119 13.9352 2.68293V3.65854H12.4936V2.68293C12.4936 2.00941 11.9558 1.46341 11.2923 1.46341H2.64288C1.97941 1.46341 1.44157 2.00941 1.44157 2.68293V17.3171C1.44157 17.9906 1.97941 18.5366 2.64288 18.5366H11.2923C11.9558 18.5366 12.4936 17.9906 12.4936 17.3171V16.3415H13.9352V17.3171C13.9352 18.7988 12.7519 20 11.2923 20H2.64288C1.18326 20 0 18.7988 0 17.3171V2.68293Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutHover);
export default __webpack_public_path__ + "static/media/sign-out-hover.24fce989.svg";
export { ForwardRef as ReactComponent };